import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const accountApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.PROFILE, EBaseApiTags.CONFIG, EBaseApiTags.PORTFOLIO],
	endpoints: {
		accountLanguageCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.CONFIG]),
		},
		accountProfileRetrieve: {
			providesTags: [EBaseApiTags.PROFILE],
		},
		accountProfileCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.PROFILE]),
		},
		accountPortfolioitemsCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.PORTFOLIO]),
		},
		accountPortfolioitemsList: {
			providesTags: [EBaseApiTags.PORTFOLIO],
		},
		accountSettingsCreate: {},
	},
});
export const {
	useAccountLanguageCreateMutation,
	useAccountProfileRetrieveQuery,
	useAccountProfileCreateMutation,
	useAccountSettingsCreateMutation,
	useAccountPortfolioitemsCreateMutation,
	useAccountPortfolioitemsListQuery,
} = accountApi;
